/**
 * Audience Selector Dropdown
 * Country / Language / Channel Selector
 */

(function (window, document, $, undefined) {
	'use strict';

	$(document).ready(function(){
		var $body              = $('body'),
			$endpointData      = [],
			activeRegion       = '',
			activeCountry      = '',
			activeInvestorType = '',
			availableLanguages = '';

		// get the channel selector endpoint data first thing
		$.getJSON( '/wp-json/channel-selector/v1/all', function( data ) {
			$.each( data, function( key, val ) {
				$endpointData.push(val);
			});
	
			jh_cs_build_regions( $endpointData );
		});

		// START triggers
		// clear the various spoke-related elements when the modal is closed
		$('#channel-selector-model').on('hidden.bs.modal', function (e) {
			jh_cs_reset_modal();
		});

		// When a region is clicked, get the corresponding object out of the $endpointData array and
		// use it to build the country dropdown
		$body.on('click', 'span.region', function(e){
			var $this = $(this);

			jh_cs_reset_modal();

			// $('span.region').removeClass('active');
			$this.addClass('active');
			
			// Set the activeRegion variable equal to the chosen region object to make finding deeper
			// data easier
			activeRegion = find_object_in_array( $endpointData, 'slug', $this.data('region-slug') );

			jh_cs_build_country_options( find_object_in_array( $endpointData, 'slug', $this.data('region-slug') ) );
		});

		$('#options--countries').change(function(e){
			var $selectedOption = $('option:selected', this);

			$('.group-languages').hide();
			$('.group-investor-types').hide();
			$('.options--investor-types').html('');
			$('.options--languages').html('');
			$('.options--language-spokes').html('');

			// Set the activeCountry variable equal to the chosen country object to make finding deeper
			// data easier
			activeCountry = find_object_in_array( activeRegion['countries'], 'slug', $selectedOption.val() );

			// Check if the chosen country should go directly to the spoke and, if so, go directly to
			// the spoke.
			if ( $selectedOption.data('direct-to-spoke') ) {
				window.location.href = build_spoke_url( $selectedOption.data('spoke') );
				return;
			}

			if ( $selectedOption.data('has-multiple-languages') ) {
				var languages = activeCountry['languages'];

				availableLanguages = languages;
				jh_build_language_options( languages );
			}

			if ( $selectedOption.data('has-investor-types') ) {
				var investorTypes         = activeCountry['spokes'],
					$groupInvestorTypes   = $('.group-investor-types'),
					$optionsInvestorTypes = $groupInvestorTypes.find('.options--investor-types');

				$groupInvestorTypes.hide();
				$optionsInvestorTypes.html('');
				activeInvestorType = $selectedOption.val();

				$optionsInvestorTypes.html( jh_build_investor_types( investorTypes ) );

				if ( $body.find( '#options--subsidiaries' ) ) {
					$('#options--subsidiaries').selectpicker('refresh');
				}
				
				$groupInvestorTypes.fadeIn('fast');
			}
		});

		$body.on('change', '#options--subsidiaries', function(e){
			window.location.href = $('option:selected', this).val();
		});

		$body.on('click', '.options--languages label', function(e){
			var $this                  = $(this),
				$optionsLanguageSpokes = $('.options--language-spokes'),
				selectedLanguage       = find_object_in_array( availableLanguages, 'slug', $this.find('[type="radio"]').val() );

			$optionsLanguageSpokes.hide();
			$optionsLanguageSpokes.html('');
			$optionsLanguageSpokes.html( jh_build_investor_types( selectedLanguage['spokes'] ) );
			$optionsLanguageSpokes.fadeIn('fast')
		} );
		// END triggers
	});

	// Generic helper function for finding a specific element in an array by property name and value
	function find_object_in_array( array, property, value){
		return array.find(function(o){
			return o[property] === value;
		});
	}

	/**
	 * The region boxes are built using the top-level objects in the array
	 * 
	 * @param $data the data returned by the channel selector endpoint
	 */
	function jh_cs_build_regions( $data ){
		var $containerRegions = $('.options--regions'),
			htmlRegions       = '';

		$.each( $data, function( index, regionData ){			
			htmlRegions += '<span class="region" data-region-slug="';
			htmlRegions += regionData['slug'] + '">';
			htmlRegions += regionData['display_name'];
			htmlRegions += '</span>';

			$containerRegions.html(htmlRegions);
		} );
	}

	/**
	 * The Country select options are built using the countries attribute of the passed-in region
	 * 
	 * @param region: the region object from the endpoint data, containing all available attributes
	 */
	function jh_cs_build_country_options( region ) {
		var $selectCountries = $('#options--countries'),
			$groupCountries  = $('.group-countries');
		
		// $groupCountries.fadeOut('fast');
		$selectCountries.html('<option value="">Select Country</option>');

		$.each( region['countries'], function(index, country){
			var option = '<option value="' + country['slug'] + '"';
			option += ' data-icon="flag-icon flag-icon-' + country['country_code'] + '"';
			option += ' data-direct-to-spoke="' + country['direct_to_spoke'] + '"';
			
			// only add this data attribute if this country should go directly to the spoke
			if ( country['direct_to_spoke'] ) {
				option += ' data-spoke="' + country['url'] + '"';
			}

			// only add this data attribute if the country has multiple languages
			if ( country['languages'] && country['languages'].length ) {
				option += ' data-has-multiple-languages="true"';
			}

			// if the coungry has spokes, set this data attribute to know to load them
			if ( country['spokes'] && country['spokes'].length ) {
				option += ' data-has-investor-types="true"';
			}

			option += '>' + country['display_name'] + '</option>';

			$selectCountries.append(option);
		} );

		$selectCountries.selectpicker('refresh');
		$groupCountries.fadeIn('fast');
	}

	function jh_build_language_options( languages ) {
		var $groupLanguages   = $('.group-languages'),
			$optionsLanguages = $('.options--languages'),
			output            = '';

		$optionsLanguages.html('');

		$.each(languages, function( index, language ) {
			output += '<label class="radio radio-gradient"><span class="radio__input"><input type="radio" name="country-languages" value="';
			output += language['slug'] + '"><span class="radio__control"></span></span>';
			output += '<span class="radio__label language-abbrev">' + language['language_code'].substring(1) + '</span>';
			output += '</label>'
		} );

		$optionsLanguages.html(output);
		$groupLanguages.fadeIn('fast');
	}


	function jh_build_investor_types( investorTypes ) {
		var output               = '',
			subsidiariesPresent  = false;

		$.each( investorTypes, function( index, investorType ){ 
			if ( investorType['has_subsidiaries'] ) {
				subsidiariesPresent = true;

				output += '<select id="options--subsidiaries" name="options--subsidiaries" class="selectpicker form-control" data-style="text-button secondary" data-width="100%" tabindex="-98">';
				output += '<option selected="selected">' + investorType['display_name'] + '</option>';
				
				$.each(investorType['subsidiaries'], function( index, subsidiary ) {
					output += '<option value="';
					output += subsidiary['external_link'] ? subsidiary['url'] : build_spoke_url( subsidiary['url'] );
					output += '">';
					output += subsidiary['display_name'];
					output += '</option>';
				} );

				output += '</select>';

			} else {
				output += '<a class="site-channel jh-btn ghost with-icon icon-r icon-arrow"';
				output += ' href="' + investorType['url'] + '"';
				output += '>' + investorType['display_name'];
				output += '</a>';
			}
		} );

		return output;
	}

	/**
	 * Creates the full URL necessary to redirect to the chosen spoke
	 * 
	 * @param spoke: the url value of the spoke's object
	 */
	function build_spoke_url( spoke ) {
		var protocol = window.location.protocol,
			hostname = window.location.hostname;
		
		return protocol + '//' + hostname + spoke;
	}

	/**
	 * Resets the modal to the default state
	 */
	function jh_cs_reset_modal(){
		$('span.region').removeClass('active');
		$('.group-countries').hide();
		$('.group-investor-types').hide();
		$('.group-languages').hide();
		$('.options--languages').html('');
		$('.options--language-spokes').html('');
		$('.options--investor-types').html('');
	}

})(window, document, jQuery);  